


































































import type Server from '@tridoc/frontend'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class TagCreator extends Vue {
  show = false
  valid = false
  label = ''
  type: 'simple' | 'date' | 'decimal' = 'simple'

  labelRules: FormRule[] = [
    v => !!v || 'Label is required',
    v => !(/\s|\/|\\|#|"|'|,|;|:|\?/.test(v)) || 'The label must not contain any of the following: whitespace / \\ # " \' , ; : ?',
    v => !(/^[.]{1,2}$/.test(v)) || 'The label must not equal . (single dot) or .. (double dot)',
  ]

  clear () {
    this.show = false
    this.label = ''
    this.type = 'simple';
    (this.$refs.form as any).resetValidation()
  }

  save () {
    (this.$refs.form as any).validate()
    const cs = this.$store.getters.server.server as Server
    if (cs && this.valid) {
      cs.createTag(this.label, this.type !== 'simple' ? this.type : undefined)
        .then((r: {error?: string}) => {
          if (r.error) {
            this.$emit('error', r)
            this.clear()
          } else {
            this.$emit('tagcreated')
            this.clear()
          }
        })
    }
  }
}
